import React from 'react'
import log from "../../assets/images/log.png"
import comLogoWhite from "../../assets/images/comLogoWhite.svg"
import { Link } from 'react-router-dom'
import { COMMBITZ_URL } from '../../config'
import styles from "./style/style.module.css"
import FooterContainer from './FooterContainer'
import CopyRight from './CopyRight'

function Footer() {
    return (

        <footer>
            <div className={styles.footerMain}>
                <div className="container-fluid">
                <FooterContainer />
                <CopyRight />
                </div>
            </div>
            {/* <span className={styles.nextPage}> <Link to={generateWhatsAppLink()} target="_blank" rel="noopener noreferrer" > <Image width="25" height="25" src={wts} alt=""/></Link></span> */}
            </footer>
        // <footer className="footer-main">
        //     <div className="container">
        //         <div className="row">
        //             <div className="col-md-12">
        //                 <div className="fottre-left text-center">
        //                     <div className='footerLogo'>
        //                         <Link to='/'><span> <img src={log} alt="" /></span></Link>
        //                         <p>Enjoy your international travel with the best debit and credit card Niyo Global and enjoy zero markups on your Forex transactions.</p>

        //                         <Link to={`${COMMBITZ_URL}`}><span><img src={comLogoWhite} alt="" /></span></Link>   
        //                     </div>
                           
        //                 </div>
        //             </div>
                

        //         </div>
        //     </div>
        // </footer>
    )
}

export default Footer